import { useTranslation, withTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  InputLabel,
  FormControl,
  NativeSelect,
} from '@material-ui/core';
import compose from 'ramda/src/compose';
import LocaleKeys from '../../../../../locales/keys';
import { makeStyles } from '@material-ui/core/styles';
import supportedTitles from './titles';
import selectBackground from '../../../../../images/select-bg.png';

const useStyles = makeStyles((theme) => ({
  fieldSelectNative: {
    '&.MuiInputBase-root': {
      border: `1px solid ${theme?.palette?.custom?.lightBlack}`,
      '&.Mui-focused': {
        boxShadow: '0 0 10px #9ecaed',
      },
    },
    '& .MuiNativeSelect-select': {
      height: '50%',
      background: `url(${selectBackground}) no-repeat right center;`,
    },
  },
  'field__select--error': {
    borderColor: theme.palette.error.main,
    borderWidth: '2px',
  },
}));

function TitleField(props) {
  const { form = {}, name, customClasses } = props;
  const { values = {} } = form;
  const { t } = useTranslation();
  const classes = useStyles();

  const options = [];
  supportedTitles.forEach((title) => {
    const displayValue = t(LocaleKeys.titles[title]);
    if (displayValue !== `titles.${title}`) {
      options.push({
        Value: title,
        Name: displayValue,
      });
    }
  });

  return (
    <Box
      className={`form-group field field--${name} ${
        customClasses && customClasses.fieldWidth
      }`}
    >
      <InputLabel>
        <Typography
          variant="body1"
          color="textPrimary"
          className={customClasses && customClasses.titilliumFont}
        >
          {t(LocaleKeys.registration.title)}
        </Typography>
      </InputLabel>
      <FormControl
        className={`field__form-control ${
          customClasses && customClasses.fieldHeight
        }`}
      >
        <NativeSelect
          data-cy="field__select"
          data-testid="title-select"
          IconComponent={() => null}
          className={`field__select ${classes.fieldSelectNative} ${
            form?.errors?.[name] ? classes['field__select--error'] : ''
          }`}
          disableUnderline
          name={name}
          value={values[name] || 'Select'}
          onChange={(event) => {
            form.setFieldValue(name, event.target.value);
          }}
          fullWidth
        >
          <option value="Select">
            {t(LocaleKeys.registration.selectTitle)}
          </option>
          {options
            ? options.map((title, index) => (
                <option value={title.Value} key={index}>
                  {title.Name}
                </option>
              ))
            : []}
        </NativeSelect>
      </FormControl>
      {form?.errors?.[name] ? (
        <Box ml={3} mt={2} className={`field__errorBox`}>
          <Typography variant="body2" color="error">
            {form.errors[name]}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}

export default compose(withTranslation())(TitleField);
